import React from 'react';
import Box from '@mui/material/Box';
import HalfSizeBanner from '../components/Banners/HalfSizeBanner';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Accordions from '../components/Accordions/Accordions';
import SmallCards from '../components/Cards/SmallCards';
import TextBtnSection from '../components/Section/TextBtnSection';
import BigCard from '../components/Cards/BigCard';
import Cards from '../components/Cards/Cards';
import { useTranslation } from '../hook/Translation';

export default function ExomindNeuromagneticBrainWellnessProgram() {
    const { t } = useTranslation();
    const accodirons = [
        {
            title: 'What it is?',
            content: 'Precise ablation at the surface plus controlled dermal heat stimulates collagen remodeling and new skin formation'
        },
        {
            title: 'How it works',
            content: 'Precise ablation at the surface plus controlled dermal heat stimulates collagen remodeling and new skin formation'
        },
    ]

    const data2 = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description: '20 to 30 min'
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description: 'Minimal tapping or clicks'
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description: 'None'
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description: '6 to 10'
        }
    ];
    const data = [
        {
            header: 'Reduces Mental Overload And Restores Emotional Balance.',
            imageUrl: `${process.env.REACT_APP_API_URL}/images/2025/12/EXOMIN_1.png`
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        },
        {
            header: 'Stabilizes Emotional Responses And Supports Mental Stability.',
            imageUrl: `${process.env.REACT_APP_API_URL}/images/2025/12/EXOMIND_2.png`
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        },
        {
            header: 'Eases Mental Fatigue And Improves Rest Quality.',
            imageUrl: `${process.env.REACT_APP_API_URL}/images/2025/12/EXOMIND_3.png`
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        },
    ]

    return (
        <Box>
            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'} bgcolor={'#1E353D'}>
                        <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2025/12/Exomind.png`} height={1} width={1} className='fitCover' />
                    </Box>
                </HalfSizeBanner>
            </Box>
            <Box className="generalContainer" marginX={'auto'} marginTop={{ md: '80px', xs: '50px' }}>
                <TextBtnSection
                    titleSize={{ md: 8, xs: 12 }}
                    // descriptionSize={{}}
                    data={{
                        type: "Mind-Body Therapies",
                        title: "Exomind Neuromagnetic Brain Wellness Program",
                        description: "Clarity, calm, and cognitive boost. Exomind is our signature mind-body neuromodulation therapy designed to improve your mental well-being and performance using safe, cutting-edge neurotechnology. In essence, it’s like a gym session for your brain combined with the tranquility of a meditation retreat.",
                        bookUrl: "/",
                        learnUrl: "/"
                    }}
                />
            </Box>

            <Box marginTop={{ md: '90px', xs: '50px' }}>
                <Box component={'img'} src='/images/fractional/Path 134.svg' width={1} sx={{ objectFit: 'cover' }} />
            </Box>

            <Box>
                <Box marginTop={{ md: '104px', xs: '50px' }} className='generalContainer' marginX={'auto'}>
                    <SmallCards data={data2} />
                </Box>
            </Box>


            <Grid container gap={{ md: '80px', xs: '30px' }} className='generalContainer' sx={{ marginX: 'auto' }} marginTop={{ md: '140px', xs: '50px' }}>
                <Grid size={12}>
                    <Typography variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={600} textAlign={'center'}>Additional Information</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>

            <Grid container className='generalContainer' sx={{ marginX: 'auto' }} gap={{ md: '20px', xs: '20px' }} marginTop={{ md: '148px', xs: '50px' }}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" className='dColor' fontWeight={'bold'} fontSize={{ md: '1.125rem', xs: '1rem' }}>
                        What It Involves
                    </Typography>
                </Grid>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" className='dColor' fontWeight={'bold'} fontSize={{ md: '30px', xs: '1.125rem' }}>
                        In a comfortable lounge chair, you’ll wear a specialized headset or recline under a device that emits gentle pulsing magnetic fields to targeted regions of your brain. Sessions typically last 20 30 minutes. You remain fully awake but deeply relaxed many clients close their eyes and drift in a state between meditation and sleep while the technology does the work.
                    </Typography>
                </Grid>
            </Grid>

            <Box sx={{ width: { md: '65%', xs: '90%' }, marginX: 'auto' }} marginTop={{ md: '140px', xs: '50px' }}>
                <Box sx={{ height: { md: 460, xs: 'auto' } }}>
                    <BigCard
                        data={{
                            book: '/',
                            type: 'Technology',
                            learn: '/',
                            title: 'Transcranial Magnetic Stimulation',
                            size: { md: 6, xs: 12 },
                            btnContainer: { md: 12, xs: 12 },
                            // flexDirection: {md: 'row-reverse', xs: 'row'},
                            description: 'Exomind leverages Transcranial Magnetic Stimulation (TMS) principles, a proven technique where magnetic fields influence neuronal activity in the brain . By delivering repetitive magnetic pulses, we can ‘tune’ brain circuits that may be under- or over-active'
                        }}
                        extraStyle={{
                            background: `linear-gradient(90deg,rgba(30, 53, 61, 1) 0%, rgba(30, 53, 61, 1) 35%, rgba(30, 53, 61, 1) 50%, rgba(202, 155, 112, 0) 100%), url("${process.env.REACT_APP_API_URL}/images/Exomind Neuromagnetic Brain Wellness Program/Mask Group 5.png") center / cover`
                        }}
                        bgColor={'unset'}
                    />
                </Box>
            </Box>

            <Grid container className='generalContainer' sx={{ marginX: 'auto', }} gap={'22px'} marginTop={{ md: '96px', xs: '50px' }}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" className='dColor' fontWeight={'bold'} fontSize={{ md: '1.125rem', xs: '1rem' }}>
                        Areas Of Effect
                    </Typography>
                </Grid>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" className='dColor' fontWeight={'bold'} fontSize={{ md: '30px', xs: '1.125rem' }}>
                        In a comfortable lounge chair, you’ll wear a specialized headset or recline under a device that emits gentle pulsing magnetic fields to targeted regions of your brain. Sessions typically last 20 30 minutes. You remain fully awake but deeply relaxed many clients close their eyes and drift in a state between meditation and sleep while the technology does the work.
                    </Typography>
                </Grid>
            </Grid>

            <Box>
                <Grid container className='generalContainer' mx={'auto'} marginTop={{ md: '148px', xs: '50px' }}>
                    <Grid size={12}>
                        <Cards data={data} headerAlign={'center'} />
                    </Grid>
                </Grid>
                <Grid container spacing={8} className="generalContainer" marginX={'auto'} mb={{ md: '82px', xs: '50px' }}>
                    <Grid container bgcolor={'#FFFFFF'} padding={{ md: 8, xs: '20px' }} marginTop={{ md: '160px', xs: '50px' }} paddingX={{ md: '101px', xs: '20px' }} position={'relative'} border={'solid 1px #DBDAD9'}>
                        <Grid size={12}>
                            <Grid container gap={'26px'}>
                                <Grid size={12}>
                                    <Typography variant="body1" textAlign={'center'} color="text.secondary" fontSize={'1rem'} fontWeight={'600'}>Note</Typography>
                                </Grid>
                                <Grid size={{ md: 11, xs: 12 }}>
                                    <Typography variant="h3" color="text.secondary" textAlign={'center'} fontSize={{ md: '30px', xs: '1.125rem' }} fontWeight={'600'}>While therapeutic, Exomind is not positioned as psychiatric treatment here but as a wellness and optimization tool. If you have severe neurological or psychiatric conditions, our specialists will evaluate suitability or coordinate with your healthcare provider.</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>
            </Box>
        </Box>
    )
}